export default "__VITE_ASSET__DGPsfxf5__"